import { ChangeEvent, useState } from "react";

import { useTranslator } from "@eo-locale/react";

import { string } from "yup";

import { VisuallyHidden } from "@chakra-ui/react";

import { Textarea } from "@chakra-ui/react";

import { Field } from "../../form-control/form-control";

import { HTMLWrapper } from "../../html-wrapper/html-wrapper";
import type { Question } from "../question";

export const validate = async (
  answer: string,
  question: Question
): Promise<string[]> => {
  let schema = string();
  if (question.required) {
    schema = schema.required();
  }
  try {
    await schema.validate(answer);
    return [];
  } catch (err: any) {
    return err.errors;
  }
};

function EssayQuestion(props: Question): JSX.Element {
  const {
    id,
    question,
    required,
    error,
    status,
    onChangeHandler,
    notes,
    existingValue
  } = props;
  const { translate } = useTranslator();

  const [inputText, setInputText] = useState(existingValue || "");

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    setInputText(event.target.value);
    if (onChangeHandler) onChangeHandler(event.target.value);
  };

  return (
    <Field.Root
      my={4}
      id={`${id}`}
      invalid={error?.length > 0 || false}
      required={required || false}
      disabled={status === "saving"}
      className={error?.length > 0 ? "ehqQuestionError" : ""}
    >
      <Field.Label>
        <HTMLWrapper html={question} />
        {required && (
          <VisuallyHidden>{`* ${translate("common.required")}`}</VisuallyHidden>
        )}
      </Field.Label>
      <Textarea
        value={inputText}
        onChange={handleChange}
        size={{ base: "lg", lg: "md" }}
        data-testid="essayQuestion-input"
        fontSize="md !important"
        fontWeight="normal"
      />
      {error?.length > 0 && (
        <Field.ErrorText data-testid="essayQuestion-errorMessage">
          <Field.ErrorIcon />
          {translate(`errors.${error}`)}
        </Field.ErrorText>
      )}
      <Field.HelperText>{notes || ""}</Field.HelperText>
    </Field.Root>
  );
}

export { EssayQuestion };
